import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthRoutingModule } from 'src/routes/auth-routing.module';
import { AuthComponent } from 'src/views/auth/auth.component';
import { LoginComponent } from 'src/components/login/login.component';
import { PasswordComponent } from 'src/components/password/password.component';
import { ResetPasswordComponent } from 'src/components/reset-password/reset-password.component';
import { MaterialModule } from 'src/modules/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PreLoginComponent } from 'src/views/pre-login/pre-login.component';
import { ConfirmAccountCreateDialogComponent } from 'src/components/confirm-account-create-dialog/confirm-account-create-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        AuthRoutingModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    declarations: [
        AuthComponent,        
        LoginComponent,
        PreLoginComponent,
        PasswordComponent,
        ResetPasswordComponent,
        ConfirmAccountCreateDialogComponent
    ]
})
export class AuthModule {   

}